import {forwardRef, SVGProps} from 'react';

export enum QuestionMoveDirection {
	Left,
	Right,
}

type Props = SVGProps<SVGSVGElement> & {direction: QuestionMoveDirection};

// eslint-disable-next-line react/display-name
export const QuestionMoveIcon = forwardRef<SVGSVGElement, Props>(({
	direction = QuestionMoveDirection.Left,
	...props
}, ref) =>
	<svg
		width='8'
		height='12'
		viewBox='0 0 8 12'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
		ref={ref}
	>
		{direction === QuestionMoveDirection.Left &&
			<path
				d='M7.41016 10.59L2.83016 6L7.41016 1.41L6.00016 0L0.000156403 6L6.00016 12L7.41016 10.59Z'
				fill='#0088CC'
			/>
		}
		{direction !== QuestionMoveDirection.Left &&
			<path
				d='M0.589844 10.59L5.16984 6L0.589844 1.41L1.99984 0L7.99984 6L1.99984 12L0.589844 10.59Z'
				fill='#0088CC'
			/>
		}
	</svg>
);
